import * as React from 'react'
import { ListSubheader } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles({
  root: {
    backgroundColor: 'transparent',
    lineHeight: '32px',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#94a3b8',
    marginTop: 12,
    paddingLeft: 16,
  },
})

const MenuSection = ({ label }) => {
  const classes = useStyles()
  return (
    <ListSubheader disableSticky className={classes.root} component="div">
      {label}
    </ListSubheader>
  )
}

MenuSection.propTypes = {
  label: PropTypes.string.isRequired,
}

export default MenuSection
